import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class ThemeService {
	private themeSubject = new BehaviorSubject<'light' | 'dark'>('light');
	theme$ = this.themeSubject.asObservable();

	setTheme(theme: string) {
		const validTheme = theme.includes('light') ? 'light' : theme.includes('dark') ? 'dark' : null;

		if (!validTheme) {
			console.warn(`Tema no válido: ${theme}`);
			return;
		}

		const themeLink = document.getElementById('theme-css') as HTMLLinkElement;
		if (themeLink) {
			themeLink.href = `/assets/themes/aura-${validTheme}-indigo/theme.css`;
		}

		document.documentElement.setAttribute('data-theme', validTheme);
		this.themeSubject.next(validTheme as 'light' | 'dark');
	}

	getTheme(): 'light' | 'dark' {
		return this.themeSubject.value;
	}
}
